import { createRef, useReducer } from "react";
import { turnstileEnabled } from "@circle-react/components/OnboardingPage/helpers/methods";

const SET_FAILED = "SET_FAILED";
const SET_SUCCESS = "SET_SUCCESS";
const SET_INTERACTIVE = "SET_INTERACTIVE";

const turnstileReducer = (state, action) => {
  switch (action.type) {
    case SET_FAILED:
      return {
        ...state,
        isLoading: false,
        hasFailed: true,
        requiresInteraction: false,
        isInteractionSuccessful: false,
      };
    case SET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasFailed: false,
        requiresInteraction: state.requiresInteraction,
        isInteractionSuccessful: state.requiresInteraction,
      };
    case SET_INTERACTIVE:
      return {
        ...state,
        isLoading: false,
        hasFailed: false,
        requiresInteraction: true,
        isInteractionSuccessful: false,
      };
    default:
      return state;
  }
};

export const useTurnstile = (forceDisabled = false) => {
  const canUseTurnstile = !forceDisabled && turnstileEnabled(window.RAILS_ENV);

  const initialTurnstileState = {
    isLoading: canUseTurnstile,
    hasFailed: false,
    requiresInteraction: false,
    isInteractionSuccessful: false,
  };

  const turnstileRef = createRef();
  const [turnstileResult, dispatch] = useReducer(
    turnstileReducer,
    initialTurnstileState,
  );
  const shouldShowTurnstile =
    canUseTurnstile &&
    !turnstileResult.isLoading &&
    (turnstileResult.requiresInteraction || turnstileResult.hasFailed);

  return {
    turnstileRef,
    turnstileResult,
    dispatch,
    canUseTurnstile,
    shouldShowTurnstile,
  };
};
